import axios from 'axios'

const portalApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://iuris.mcmnxcloud.com'
})

// Attach portal JWT — completely separate from staff session
portalApi.interceptors.request.use(config => {
  const token = sessionStorage.getItem('lextrack_portal_token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

portalApi.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      const url = error.config?.url || ''
      // Don't redirect for the login endpoint itself — let the page render its error.
      if (!/\/api\/portal\/login/.test(url)) {
        sessionStorage.removeItem('lextrack_portal_token')
        if (!window.location.pathname.startsWith('/portal/login')) {
          window.location.href = '/portal/login'
        }
      }
    }
    return Promise.reject(error)
  }
)

export default portalApi
